import { useEffect, DragEventHandler, useState, useRef } from "react";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from "../../../Root";
import { closelightbox } from "../../../../util/Functions";
import { FortknoxService } from "../../../../services/FortknoxService";
import { useDialog } from "@albo-ui/core";
import { readCsvFile } from "../../../../util/ReadCsvFile";

export const useGenerateInfo = (open: boolean, changeAlert: ChangeAlertCallbackType, changeLoader: ChangeLoaderCallbackType) => {
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [zPos, setZPos] = useState(45);
    const dialogProps = useDialog();
    const fortknoxService = useRef<FortknoxService>();

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [form, setForm] = useState(null);
    const [execute, setExecute] = useState(null);
    const dropZoneRef = useRef<null | HTMLDivElement>(null);

    const parseJson = async (csv) => {
        changeLoader(true);
        setZPos(-1);
        setIsValidForm(true);
        setError(null);
        
        const request = await readCsvFile(csv, 50);
        if (request) {
            setForm(JSON.parse(JSON.stringify(request)));
            setIsValidForm(false);
        } else {
            changeAlert(true, "error", "Ocurrió un error, por favor intenta de nuevo.");
        }

        changeLoader(false);
        setZPos(45);
    };

    const onSelectFile = (e) => {
        let csv = e.target.files[0];
        let extension = (name) => {
            return ["csv", "xls", "xlsx"].indexOf(name.split('.').pop()) === -1 ? true : false
        }

        if (!csv) {
            changeAlert(true, "error", "Error en selección de archivo");
        } else if (extension(csv.name)) {
            changeAlert(true, "error", "Error: El tipo de archivo no es permitido.");
        } else {
            parseJson(csv);
        }
    };

    const handleOver: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (dropZoneRef.current) {
            dropZoneRef.current.style.borderColor = "#1890ff";
            dropZoneRef.current.style.borderWidth = "2px";
            dropZoneRef.current.style.backgroundColor = "rgba(119, 119, 255,0.1)";
        }
    };

    const handleLeave: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (dropZoneRef.current) {
            dropZoneRef.current.style.borderColor = "lightgray";
            dropZoneRef.current.style.borderWidth = "1px";
            dropZoneRef.current.style.backgroundColor = "transparent";
        }
    };

    const handleDrop: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            const filesToUpload = [];
            for (let i = 0; i < event.dataTransfer.files.length; i++) {
                filesToUpload.push(event.dataTransfer.files.item(i));
            }

            if (filesToUpload.length > 0) {
                parseJson(filesToUpload[0]);
                handleLeave(event);
            }
            event.dataTransfer.clearData();
        }
    };

    const onHandleChange = (key, e) => {
        let f = form || {};
        let value = e.target.value;

        if(key && value){
            f[key] = value;
        }
        if (f["fechaInicio"] && f["fechaFin"]) {
            setIsValidForm(false);
        } else {
            setIsValidForm(true);
        }

        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onClose = () => {
        dialogProps.onClose();
    };

    const onConfirm = async () => {
        changeLoader(true);
        setZPos(-1);

        const payload = execute === "file" ? {lines: form["lines"]} : form
        const response = await fortknoxService.current.generateTxInfo(payload);
        if (response?.data?.response === "OK") {
            let paths = response.data.content["files_paths"]
            paths && paths.length > 0 ? onDownloadFile(paths) : changeAlert(true, 'error', "No se encontraron resultados.");
			changeAlert(true, 'success', "Descarga realizada con éxito.");
            changeLoader(false);
            closelightbox();
        } else {
			changeAlert(true, 'error', response["message"] || "Error al obtener documentos.");
            changeLoader(false);
            setZPos(45);
        }
    };

    const onDownloadFile = async (files) => {
        if (files) {
            files.map( async (i) => {
                let link =  `${i.replace("gs:/", "https://storage.cloud.google.com")}?authuser=0`
                window.open(link, "_blank");
            })
        }
        return true

    };

    const onFormReset = () => {
        setForm(null);
        setError(null);
        setIsValidForm(true);
    };

    useEffect(() => {
        fortknoxService.current = new FortknoxService(changeAlert);

        if (!open) {
            setData([]);
            setForm(null);
            setError(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return {
        data,
        form,
        zPos,
        isValidForm,
        dropZoneRef,
        error,
        execute,
        onSelectFile,
        onClose,
        onConfirm,
        handleOver,
        handleLeave,
        handleDrop,
        onFormReset,
        setExecute,
        onHandleChange
    };
};
